import React from 'react';
import Authentication from '../Authentication';


function FormLogin() {
  return (
    <div className="login-card">
      <Authentication />
    </div>
  );
}

export default FormLogin;
